import { render, staticRenderFns } from "./ConfigPiece.vue?vue&type=template&id=d04f4552&scoped=true"
import script from "./ConfigPiece.vue?vue&type=script&lang=js"
export * from "./ConfigPiece.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04f4552",
  null
  
)

export default component.exports